<form 
    name="productForm" 
    class="product w-100-p" 
    fxLayout="column" 
    fxFlex
    id="cliente-renda-variavel"
>
    <mat-tab-group>   
        
        <mat-tab label="Custódia Atual de Ações">
            <ng-template matTabContent>
                <lista-estrategia-custodia 
                    [cliente_id]="client.id">
                </lista-estrategia-custodia>
            </ng-template>
        </mat-tab>  

        <mat-tab label="Calculadora RV" matTooltip="Calculadora RV">
            <ng-template matTabContent>
                <app-feedback-cliente></app-feedback-cliente>
            </ng-template>
        </mat-tab>
        
        <mat-tab label="Movimentação Operações RV">
            <ng-template matTabContent>
                <app-lista-historico-cliente></app-lista-historico-cliente>
            </ng-template>
        </mat-tab>
              
    </mat-tab-group>
</form>